<template>
  <div class="lg2:flex pb-20 pt-9">
    <ul class="lg2:w-90 font-medium lg2:pr-10 text-lg">
      <li class="pb-2.5">
        <router-link
          class="profile-links rounded-lg"
          :class="routeName == '#' ? 'bg-blue text-white rounded-lg' : 'bg-smoke-100'"
          to="#"
        >
          <img src="@/assets/icons/dashboard.svg" class="w-6 h-5"/>
          <span class="pl-3 leading-8">Dashboard</span>
        </router-link> 
      </li>
      <li class="pb-2.5">
        <router-link
          class="profile-links rounded-lg"
          :class="routeName == 'My Account' ? 'bg-blue text-white rounded-lg' : 'bg-smoke-100'"
          :to="{name: 'My Account'}"
        >
          <img src="@/assets/icons/accountSetting.svg" class="w-6 h-5"/>
          <span class="pl-3 leading-8">My Account</span>
        </router-link> 
      </li>
      <li v-if="$route.fullPath.includes('my-account')" class="mb-2.5 bg-smoke-100 rounded-lg">
        <router-link
          class="profile-links rounded-t-lg"
          :class="routeName == 'Profile' ? 'bg-blue text-white rounded-lg' : 'bg-smoke-100'"
          :to="{name: 'Profile'}"
        >
          <div class="flex pl-9 items-center">
            <img v-if="routeName == 'Profile'" src="@/assets/icons/profileWhite.svg" class="w-6 h-5"/>
            <img v-else src="@/assets/icons/profile.svg" class="w-6 h-5"/>
            <span class="pl-3 leading-8">Profile</span>
          </div>
        </router-link>
        <router-link
          class="profile-links"
          :class="routeName == 'WorkExperience' ? 'bg-blue text-white rounded-lg' : 'bg-smoke-100'"
          :to="{name: 'WorkExperience'}"
        >
          <div class="flex pl-9 items-center">
            <img v-if="routeName == 'WorkExperience'" src="@/assets/icons/cupWhite.svg" class="w-6 h-5"/>
            <img v-else src="@/assets/icons/cupBlack.svg" class="w-6 h-5"/>
            <span class="pl-3 leading-8">Work Experience</span>
          </div>
        </router-link>
        <router-link
          class="profile-links"
          :class="routeName == 'ProductsSourced' ? 'bg-blue text-white rounded-lg' : 'bg-smoke-100'"
          :to="{name: 'ProductsSourced'}"
        >
          <div class="flex pl-9 items-center">
            <img v-if="routeName == 'ProductsSourced'" src="@/assets/icons/whiteCamera.svg" class="w-6 h-5"/>
            <img v-else src="@/assets/icons/blackCamera.svg" class="w-6 h-5"/>
            <span class="pl-3 leading-8">Products Sourced</span>
          </div>
        </router-link>
        <router-link
          class="profile-links"
          :class="routeName == 'IdentityDocuments' ? 'bg-blue text-white rounded-lg' : 'bg-smoke-100'"
          :to="{name: 'IdentityDocuments'}"
        >
          <div class="flex pl-9 items-center">
            <img v-if="routeName == 'IdentityDocuments'" src="@/assets/icons/whiteIdentity.svg" class="w-6 h-5"/>
            <img v-else src="@/assets/icons/blackIdentity.svg" class="w-6 h-5"/>
            <span class="pl-3 leading-8">Identity Documents</span>
          </div>
        </router-link>
        <router-link
          class="profile-links rounded-b-lg"
          :class="routeName == 'PaymentDetails' ? 'bg-blue text-white rounded-lg' : 'bg-smoke-100'"
          :to="{name: 'PaymentDetails'}"
        >
          <div class="flex pl-9 items-center">
            <img v-if="routeName == 'PaymentDetails'" src="@/assets/icons/whiteCard.svg" class="w-6 h-5"/>
            <img v-else src="@/assets/icons/blackCard.svg" class="w-6 h-5"/>
            <span class="pl-3 leading-8">Payment Details</span>
          </div>
        </router-link>
      </li>
      <li class="pb-2.5">
        <router-link
          class="profile-links rounded-lg"
          :class="routeName == '#' ? 'bg-blue text-white rounded-lg' : 'bg-smoke-100'"
          to="#"
        >
          <img src="@/assets/icons/projects.svg" class="w-6 h-5"/>
          <span class="pl-3 leading-8">My Sourcing Projects</span>
        </router-link> 
      </li>
      <li class="pb-2.5">
        <router-link
          class="profile-links rounded-lg"
          :class="routeName == 'ChangePassword' ? 'bg-blue text-white rounded-lg' : 'bg-smoke-100'"
          :to="{name: 'ChangePassword'}"
        >
          <img v-if="routeName == 'ChangePassword'" src="@/assets/icons/whiteLock.svg" class="w-6 h-5"/>
          <img v-else src="@/assets/icons/blackLock.svg" class="w-6 h-5"/>
          <span class="pl-3 leading-8">Change Password</span>
        </router-link> 
      </li>
      <li class="profile-links rounded-lg bg-smoke-100 cursor-pointer" @click="signOut">
        <i class="w-6 icon-exit"></i>
        <span class="pl-3 leading-8">Logout</span>
      </li>
    </ul>
    <div class="w-primary-section mt-10 lg2:mt-0 pb-30">
      <div class="rounded-lg bg-smoke-100 p-5 md:py-7 md:px-12">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import store from '@/store/index'

export default {
  name: 'MyAccount',
  beforeRouteEnter: async (to, from, next) => {
    if (!store.getters.isUserLoggedIn) {
      next({ name: 'Home' })
    }
    next()
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions ([
      'logout',
    ]),
    async signOut() {
      await this.logout()
      // this.$router.push({ name: 'Home' })
      window.location = process.env.VUE_APP_SERVER_BASE_URL
    }
  }
}
</script>
<style lang="scss" scoped>
  .profile-links {
    @apply flex items-center py-2 px-5;
  }
  .w-primary-section {
    @apply w-full;
    @screen lg2 { width: calc(100% - 22.5rem)}
  }
</style>